import { Textarea } from '@/components/ui/textarea';

/**
 * The two messages of a notice: the one sent now, and the one sent after the
 * recipient agrees. Create Notification and HWCG group actions share this so a
 * second step is not a separate editor.
 */
export function TwoStepNoticeFields({
  stepOne,
  stepOneValue,
  onStepOne,
  stepTwo,
  stepTwoValue,
  onStepTwo,
}: {
  stepOne?: { label: string; title: string; hint: string };
  stepOneValue?: string;
  onStepOne?: (next: string) => void;
  stepTwo: { label: string; title: string; hint: string };
  stepTwoValue: string;
  onStepTwo: (next: string) => void;
}) {
  return (
    <div className="tw:space-y-4">
      {stepOne && onStepOne ? (
        <ScriptField
          step={stepOne.label}
          title={stepOne.title}
          hint={stepOne.hint}
          value={stepOneValue ?? ''}
          onChange={onStepOne}
        />
      ) : null}
      <ScriptField
        step={stepTwo.label}
        title={stepTwo.title}
        hint={stepTwo.hint}
        value={stepTwoValue}
        onChange={onStepTwo}
      />
    </div>
  );
}

function ScriptField({
  step,
  title,
  hint,
  value,
  onChange,
}: {
  step: string;
  title: string;
  hint: string;
  value: string;
  onChange: (next: string) => void;
}) {
  return (
    <div className="tw:grid tw:gap-1.5">
      <div className="tw:text-[11px] tw:font-semibold tw:uppercase tw:tracking-wide tw:text-muted-foreground">
        {step}
      </div>
      <div className="tw:text-sm tw:font-medium">{title}</div>
      <Textarea
        aria-label={title}
        rows={4}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <p className="tw:m-0 tw:text-xs tw:text-muted-foreground">{hint}</p>
    </div>
  );
}
